import { createContext } from 'react';

const FilterGroupContext = /*#__PURE__*/ createContext({
    filters: {},
    currentFilter: '',
    menuDisplays: [],
    setFilter: ()=>null,
    setCurrentFilter: ()=>null,
    clear: ()=>null,
    reset: ()=>null
});

export { FilterGroupContext };
//# sourceMappingURL=context.es.js.map
